<template>
    <div class="asset-container">
        <!-- 主内容区域 -->
        <main-content  ref="mainContent">  </main-content>
        <div style="text-align: left;margin: 5px 0">
            <el-button size="mini" class="greybtn" style="width: 60px;" @click="goBack">返回</el-button>
        </div>
        <!--搜索栏-->
		<div class="filter-container" style="padding-left: 4%">
			<el-form inline :model="pageRequest" ref="filters">
                <el-form-item label="客户编码">
                    <el-input v-model="pageRequest.code" placeholder="客户编码" style="width:80px"></el-input>
                </el-form-item>
                <el-form-item label="客户昵称">
                    <el-input v-model="pageRequest.nick_name" placeholder="客户昵称" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名">
                    <el-input v-model="pageRequest.name" placeholder="真实姓名" style="width:80px"></el-input>
                </el-form-item>
                <el-form-item label="操作时间" class="timeRange">
                    <el-date-picker v-model="pageRequest.created_at" type="datetimerange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels
                                    value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-form-item>
                <el-button class="bluebtn" @click="findPage(null)">查询</el-button>
                <el-button type="info" @click="reset">重置</el-button>
			</el-form>
		</div>
        <div style="overflow: hidden;padding-left:4%">
            <!-- 表格栏 -->
            <div class="table-container" style="float: left;width: 47%;border:1px solid #EBEEF5;">
                <el-table class="in-table" border :data="tableData" :header-cell-style="{backgroundColor:'#ccc', 'text-align':'center'}"
                          :highlight-current-row = "true"
                          @row-click="handleClientSelectChange" :max-height="maxheight + 'px'" v-loading="loading">
                    <el-table-column label="客户编码" prop="code" min-width="60">
                        <template slot-scope="scope">
                            <label v-if="scope.row.get_customer_integral">{{scope.row.get_customer_integral.code}}</label>
                        </template>
                    </el-table-column>
                    <el-table-column label="昵称" prop="nick_name" min-width="100">
                        <template slot-scope="scope">
                            <label v-if="scope.row.get_customer_integral">{{scope.row.get_customer_integral.nick_name}}</label>
                        </template>
                    </el-table-column>
                    <el-table-column label="真实姓名" prop="name" min-width="80">
                        <template slot-scope="scope">
                            <label v-if="scope.row.get_customer_integral">{{scope.row.get_customer_integral.name}}</label>
                        </template>
                    </el-table-column>
                    <el-table-column label="剩余积分" prop="surplus" min-width="60">
                        <template slot-scope="scope">
                            <label>{{scope.row.add - scope.row.reduce}}</label>
                        </template>
                    </el-table-column>
                    <el-table-column label="充值积分" prop="add" min-width="60"></el-table-column>
                    <el-table-column label="扣减积分" prop="reduce" min-width="60"></el-table-column>
                    <el-table-column label="起始时间" prop="startTime" min-width="120"></el-table-column>
                    <el-table-column label="截止时间" prop="endTime" min-width="120"></el-table-column>
                </el-table>
                <!-- 分页栏 -->
                <div class="toolbar-pagination">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            layout=" sizes, prev, pager, next, jumper"
                            :total="pageRequest.totalSize"
                            :page-size="pageRequest.pageSize"
                            :current-page="pageRequest.pageNum"
                            :page-sizes="[30, 50, 80, 100, 150, 200, 300, 500, 1000]">

                    </el-pagination>
                </div>
            </div>
            <!-- 第2个table -->
            <div class="table-container" style="float: left;width: 49%;margin-left: 1%;">
                <el-table class="detail_table" border :data = this.integralLogArr :max-height="maxheight + 'px'" v-loading="loading"
                          :row-class-name='TableRowClassName'
                          :header-cell-style="{backgroundColor:'#ccc', 'text-align':'center'}">
                    <el-table-column label="操作人" prop="created_name" width="150"></el-table-column>
                    <el-table-column label="操作时间" prop="created_at" width="130"></el-table-column>
                    <el-table-column label="积分变化" prop="integral" width="80">
                        <template slot-scope="scope">
                            <label v-if="scope.row.type === 1" >+{{scope.row.integral}}</label>
                            <label v-if="scope.row.type === 2" >-{{scope.row.integral}}</label>
                        </template>
                    </el-table-column>
                    <el-table-column label="总积分" prop="total_integral" width="80"></el-table-column>
                    <el-table-column label="操作记录" prop="note"></el-table-column>
                </el-table>
            </div>
        </div>

    </div>
</template>

<script>
import Cookies from "js-cookie"
import MainContent from "../MainContent/MainContent"
export default {
    components: {
        MainContent
    },
    data(){
        return {
            size: 'small',
            authArr:[{
                id: 1,
                name: '已授权'
            },{
                id: 2,
                name: '取消授权'
            }],
            tableData:[{}],
            pageRequest: {
                id: '',
                to_nick_name: '',
                to_name: '',
                name: '',
                nick_name: '',
                code:'',
                created_at: '',
                pageNum: 1,
                pageSize: 30,
            },
            maxheight:0,
            loading: false,
            //被选中
            merchantSelectedIds: [],
            integralLogArr: [],
            selectRow: [],

            // 按钮权限
			perms:{
              view: true,
			  export: true
            },
        }
    },
    created(){
        this.maxheight = window.innerHeight - 200
    },
    methods: {
        handleSelectChange(val){
            this.merchantSelectedIds = [];
            for (let selectedItem of val) {
                this.merchantSelectedIds.push(selectedItem.id)
            }
        },
        //监听 pagesize 改变的事件
        handleSizeChange(newSize){
            this.pageRequest.pageSize = newSize
            this.findPage()
        },
        //监听 页码值 改变的事件
        handleCurrentChange(current){
            this.pageRequest.pageNum = current
            this.findPage()
        },
        reset() {
            this.pageRequest.name =  ''
            this.pageRequest.nick_name =  ''
            this.pageRequest.code = ''
            this.pageRequest.created_at = ''
            this.pageRequest.pageNum = 1
            this.pageRequest.pageSize = 30
            this.findPage(null)
        },
        findPage() {
            this.loading = true;
            this.integralLogArr = []
            var params = this.$route.query.params

            this.pageRequest.id = params.id
            this.pageRequest.to_nick_name = params.nick_name
            this.pageRequest.to_name = params.name
            this.$api.client.getIntegralDetail(this.pageRequest).then((res) => {
                this.tableData = res.data
                this.pageRequest.totalSize = res.count
                this.loading = false;
            })
        },
        handleClientSelectChange(val) {
            var params ={
                'customer_id': val.customer_id,
                'created_name': val.created_name,
                'to_created_name': '自动扣减'
            }
            this.$api.client.integralLog(params).then(res => {
                this.integralLogArr = res.data
            });
        },
        goBack() {
            this.$router.go(-1);
            this.$refs.mainContent.tabsCloseCurrentHandle();
        },
        TableRowClassName({row, rowIndex})
        {
            if (row['created_name'] == '自动扣减') {
                return 'detail_color'
            } else {
                return ''
            }
        }
    },
    mounted() {
        this.findPage()
    },
    computed: {
        headers() {
            return{
                "Authorization": Cookies.get('token') // 直接从本地获取token就行
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    /*@import "../../assets/base/deliver.css";*/
 .table-container{
	position: relative;
}
</style>
<style>
    .in-table .el-table__body tr.current-row>td.el-table__cell {
        background-color: #0378b7!important;
        color: white;
    }

    /*鼠标移入某行时的背景色*/
    .in-table .el-table__row:hover > td {
        background-color: white!important;
    }

    .detail_table .detail_color{
        background-color: #E8DDEB;
    }
    .detail_table .detail_color:hover>td{
        background-color: #E8DDEB!important;
    }
</style>


// WEBPACK FOOTER //
// src/views/Report/IntegralDetail.vue